import React, { Component } from "react";
import { QUESTION_IDS, ANSWER_IDS, STRINGS, UI } from "../constants";
import { track } from "@amplitude/analytics-browser";
import { AMPLITUDE_EVENTS } from "../config/amplitude";
import { UserDetailsService } from "../services/userDetailsService";

class Slide2_3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxes: [],
      errors: {},
    };
  }

  componentDidMount() {
    // Track survey step view
    track(AMPLITUDE_EVENTS.SURVEY_VIEW_STEP, {
      page_type: "Slide2_3",
      step: this.props.values.step,
      requestId: this.props.values.requestId,
      medium: this.props.values.medium,
    });

    // Use centralized service to fetch user details
    UserDetailsService.fetchAndUpdateState(
      this.props.values.requestId,
      this,
      'checkboxes',
      {
        componentName: "Slide2_3",
        medium: this.props.values.medium,
      }
    );
  }

  handlesubmit = event => {
    if (this.validateForm()) {
      const obj15 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: this.props.values.location,
        questionId: QUESTION_IDS.LOCATION_IMPORTANCE_DECISION,
        responseInfo: STRINGS.NA,
        createDt: this.props.values.date,
      };
      if (this.props.values.communicating === ANSWER_IDS.YES_COMMUNICATION) {
        var communicatingyes = this.props.values.communicatingyes.toString();
      } else {
        var communicatingyes = STRINGS.NA;
      }
      const obj16 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: this.props.values.communicating,
        questionId: QUESTION_IDS.NEED_COMMUNICATION_HELP,
        responseInfo: communicatingyes,
        createDt: this.props.values.date,
      };

      if (this.props.values.decision_making === "") {
        var decision_making = STRINGS.NA;
      } else {
        var decision_making = this.props.values.decision_making;
      }

      const obj17 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: ANSWER_IDS.DECISION_ANSWER,
        questionId: QUESTION_IDS.ASSIST_DECISION_MAKING,
        responseInfo: decision_making,
        createDt: this.props.values.date,
      };

      // console.log(obj15,obj16,obj17)
      this.props.handleSubmit3(obj15, obj16, obj17);
    }
  };

  validateForm() {
    let errors = {};
    let formIsValid = true;
    if (this.props.values.location === "") {
      formIsValid = false;
      errors["locationerror"] = "Kindly select an option below to proceed";
    }

    if (this.props.values.communicating === "") {
      formIsValid = false;
      errors["communicatingerror"] = "Kindly select an option below to proceed";
    }
    // if(this.props.values.decision_making === ""){
    //     formIsValid = false;
    //     errors["decisionmakingerror"] = "Kindly select an option below to proceed";
    // }
    if (
      this.props.values.communicating === ANSWER_IDS.YES_COMMUNICATION &&
      !this.props.values.communicatingyes.length
    ) {
      formIsValid = false;
      errors["communicatingyeserror"] =
        "Kindly select an option below to proceed";
    }

    this.setState({
      errors: errors,
    });

    // Track validation errors if form is invalid
    if (!formIsValid) {
      track(AMPLITUDE_EVENTS.SURVEY_ANSWER_SUBMISSION_ERROR, {
        component: "Slide2_3",
        error: "Form validation failed",
        requestId: this.props.values.requestId,
        medium: this.props.values.medium,
        step: "slide2_3_form_validation",
        validationErrors: errors,
        errorMessages: Object.values(errors),
        errorCount: Object.keys(errors).length,
      });
    }

    return formIsValid;
  }

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const { handleInput, handlecheckbox3, values } = this.props;
    return (
      <>
        <section className="feedback-service">
          <div className="container" style={{ textAlign: "left" }}>
            <div className="row">
              <div className="col-md-12">
                <h2>
                  Is there anything we can do to assist you with your decision
                  making process?
                  <div id="rsp_email" className="error">
                    {this.state.errors.decisionmakingerror}
                  </div>
                </h2>
                <input
                  type="text"
                  style={{ marginBottom: UI.MARGIN_BOTTOM }}
                  className="additional"
                  value={values.decision_making}
                  name="decision_making"
                  onChange={handleInput(this)}
                ></input>
              </div>
              <div className="col-md-12">
                <h2>
                  Do you need help communicating with any of the advisors?
                  <div id="rsp_email" className="error">
                    {this.state.errors.communicatingerror}
                  </div>
                  <div id="rsp_email" className="error">
                    {this.state.errors.communicatingyeserror}
                  </div>
                </h2>

                <label className="radio-inline">
                  <input
                    type="radio"
                    name="communicating"
                    value={ANSWER_IDS.NO_COMMUNICATION}
                    checked={
                      values.communicating === ANSWER_IDS.NO_COMMUNICATION
                    }
                    onChange={handleInput(this)}
                  />
                  No
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="communicating"
                    value={ANSWER_IDS.YES_COMMUNICATION}
                    checked={
                      values.communicating === ANSWER_IDS.YES_COMMUNICATION
                    }
                    onChange={handleInput(this)}
                  />
                  Yes
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="communicating"
                    value={ANSWER_IDS.NO_LONGER_INTERESTED}
                    checked={
                      values.communicating === ANSWER_IDS.NO_LONGER_INTERESTED
                    }
                    onChange={handleInput(this)}
                  />
                  I'm no longer interested
                </label>
              </div>

              <div className="col-md-12">
                <p className="communicatingyes">If yes:</p>
                {this.state.checkboxes.map(checkbox => (
                  <label className="radio-inline" key={checkbox.sellerId}>
                    <input
                      type="checkbox"
                      disabled={
                        values.communicating !== ANSWER_IDS.YES_COMMUNICATION
                          ? "disabled"
                          : null
                      }
                      checked={values.communicatingyes.includes(
                        checkbox.sellerNm + "(Sid-" + checkbox.sellerId + ")"
                      )}
                      value={checkbox.sellerId}
                      onChange={handlecheckbox3(checkbox.sellerNm)}
                    />
                    {checkbox.sellerNm}
                  </label>
                ))}
              </div>
              <div className="col-md-12">
                <h2>
                  How important is the location and the distance of your desired
                  advisor from where you are located?
                  <div id="rsp_email" className="error">
                    {this.state.errors.locationerror}
                  </div>
                </h2>

                <label className="radio-inline">
                  <input
                    type="radio"
                    name="location"
                    value={ANSWER_IDS.LOCATION_NOT_IMPORTANT}
                    checked={
                      this.props.values.location ===
                      ANSWER_IDS.LOCATION_NOT_IMPORTANT
                    }
                    onChange={handleInput(this)}
                  />
                  Not important
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="location"
                    value={ANSWER_IDS.LOCATION_SOMEWHAT_IMPORTANT}
                    checked={
                      this.props.values.location ===
                      ANSWER_IDS.LOCATION_SOMEWHAT_IMPORTANT
                    }
                    onChange={handleInput(this)}
                  />
                  Somewhat important
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="location"
                    value={ANSWER_IDS.LOCATION_VERY_IMPORTANT}
                    checked={
                      this.props.values.location ===
                      ANSWER_IDS.LOCATION_VERY_IMPORTANT
                    }
                    onChange={handleInput(this)}
                  />
                  Very important
                </label>
              </div>

              <div className="col-md-3"></div>
              <div className="col-md-6">
                <input
                  type="button"
                  name="previous"
                  className="next btn-update action-button nextOne"
                  style={{ cursor: "pointer" }}
                  value="PREVIOUS"
                  onClick={this.back}
                />
                <input
                  type="button"
                  name="next"
                  className="next btn-update action-button nextOne"
                  style={{
                    cursor: "pointer",
                    marginLeft: UI.MARGIN_LEFT,
                  }}
                  value="NEXT"
                  onClick={this.handlesubmit}
                />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Slide2_3;
